'use strict';

const MIN_NATIONAL_DIGITS = 6;

/**
 * Checks whether a phone number from react-telephone-input contains
 * enough real (national) digits beyond the country dial code.
 *
 * @param {string} phoneNumber - Formatted number, e.g. "+1 (555) 123-4567"
 * @param {string} dialCode    - Country dial code, e.g. "1", "44", "682"
 * @returns {boolean}
 */
export function isValidPhoneNumber(phoneNumber, dialCode) {
    const digits = (phoneNumber || '').replace(/\D/g, '');
    const nationalDigits = dialCode && digits.startsWith(dialCode)
        ? digits.slice(dialCode.length)
        : digits;

    return nationalDigits.length >= MIN_NATIONAL_DIGITS;
}
